import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LogService } from '../../../shared/log/log.service';
import { ReservationStatusCode } from '../../models/reservation-status-code.enum';
import { ReservationCompareStore } from '../../service/reservation-compare-store';
import { isNullOrUndefined } from 'util';
import { OnyxEvent } from '../../models/event';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'pioneer-reservation-filter',
  templateUrl: './reservation-filter.component.html'
})
export class ReservationFilterComponent implements OnInit {

  private activeStatusCodes: Array<ReservationStatusCode> = ReservationCompareStore.STATUS_CODES;

  public ReservationStatusCode = ReservationStatusCode;

  public onyxEvent: OnyxEvent;

  public reserved = true;
  public checkedIn = true;
  public checkedOut = true;
  public cancelled = true;
  public noShow = true;
  public rsvp = true;

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  constructor(private logService: LogService,
              private reservationCompareStore: ReservationCompareStore) {
  }

  ngOnInit() {
    this.reservationCompareStore.getActiveStatusCodes().subscribe((statusCodes: ReservationStatusCode[]) => {

      this.reserved = this.isPresent(ReservationStatusCode.RESERVED, statusCodes);

      this.checkedOut = this.isPresent(ReservationStatusCode.CHECKED_OUT, statusCodes);

      this.checkedIn = this.isPresent(ReservationStatusCode.CHECKED_IN, statusCodes);

      this.cancelled = this.isPresent(ReservationStatusCode.CANCELLED, statusCodes);

      this.noShow = this.isPresent(ReservationStatusCode.NO_SHOW, statusCodes);
    });
  }

  toggleReserved() {
    this.toggleStatusCode(ReservationStatusCode.RESERVED);
  }

  toggleCheckedIn() {
    this.toggleStatusCode(ReservationStatusCode.CHECKED_IN);
  }

  toggleCheckedOut() {
    this.toggleStatusCode(ReservationStatusCode.CHECKED_OUT);
  }

  toggleCancelled() {
    this.toggleStatusCode(ReservationStatusCode.CANCELLED);
  }

  toggleNoShow() {
    this.toggleStatusCode(ReservationStatusCode.NO_SHOW);
  }

  toggleRsvp() {
    this.toggleStatusCode(ReservationStatusCode.RSVP);
  }

  isPresent(statusCode: ReservationStatusCode, statusCodes: ReservationStatusCode[]): boolean {
    return !isNullOrUndefined(statusCodes.find(code => code === statusCode));
  }

  getActiveStatusCodes(): Observable<Array<ReservationStatusCode>> {
    return this.reservationCompareStore.getActiveStatusCodes();
  }

  getSummarySelected(): Observable<boolean> {
    return this.reservationCompareStore.getShowReservationSummary();
  }

  updateModelWithStatusCode(statusCode: ReservationStatusCode, value: boolean) {
    switch (statusCode) {
      case ReservationStatusCode.CANCELLED:
        this.cancelled = value;
        break;
      case ReservationStatusCode.CHECKED_OUT:
        this.checkedOut = value;
        break;
      case ReservationStatusCode.CHECKED_IN:
        this.checkedIn = value;
        break;
      case ReservationStatusCode.RESERVED:
        this.reserved = value;
        break;
      case ReservationStatusCode.NO_SHOW:
        this.noShow = value;
        break;
      case ReservationStatusCode.RSVP:
        this.rsvp = value;
        break;
    }
  }

  toggleStatusCode(statusCode: ReservationStatusCode): void {

    this.logService.verbose(`toggleStatusCode ${statusCode} `);

    let statusCodes = this.reservationCompareStore.getInstantActiveStatusCodes()

    const isPresent: boolean = this.isPresent(statusCode, statusCodes);

    this.logService.verbose(`toggleStatusCode ${isPresent} - ${JSON.stringify(statusCodes)}`);

    this.updateModelWithStatusCode(statusCode, !isPresent);
    if (isPresent) {
      this.updateStatusCode(statusCodes.filter(code => code !== statusCode));
    } else {
      this.updateStatusCode(statusCodes.concat([ statusCode ]));
    }
  }

  updateStatusCode(statusCodes: Array<ReservationStatusCode>) {
    this.logService.verbose(`UpdateStatusCode: ${JSON.stringify(statusCodes)}`);
    this.reservationCompareStore.setActiveStatusCodes(statusCodes);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/reservations/reservation-filter/reservation-filter.component.ts